import { Entity } from './entity';

export interface LabelConfigParameters extends Entity {
  color: string;
  label: string;
  methodTypeId: string;
}

export class LabelConfig implements Entity {
  constructor(private attributes: LabelConfigParameters) {}

  public get id(): string | undefined {
    return this.attributes.id;
  }

  public get color(): string {
    return this.attributes.color;
  }

  public get label(): string {
    return this.attributes.label;
  }

  public get methodTypeId(): string {
    return this.attributes.methodTypeId;
  }

  public get createdAt(): Date | undefined {
    return this.attributes.createdAt;
  }

  public get updatedAt(): Date | undefined {
    return this.attributes.updatedAt;
  }
}
